export const BRAND = "Shawnie & Aunnie Presents...";
export const TAGLINE = "Transformational Wellness Retreats & Empowerment Experiences";
export const DIVISION = "A division of Pic N Pak Tours and Travel Company";
export const CALENDLY_URL = "https://calendly.com/wanderpreneuragency-info/30min";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  email: "shawnieaunnie@gmail.com",
  phone: "310-293-8722",
  phoneHref: "tel:+13102938722",
  website: "shawnieaunnie.com",
  websiteHref: "https://shawnieaunnie.com",
  instagram: "https://www.instagram.com/shawnieaunniepresents",
  instagramHandle: "@shawnieaunniepresents",
  tiktok: "https://www.tiktok.com/@pic.n.pak.tours.a",
  tiktokHandle: "@pic.n.pak.tours.a",
};

export const SHORT_BIO =
  "Shawnie & Aunnie Presents... is the joint venture of two Los Angeles entrepreneurs and friends of more than 30 years — bonded by a shared loss that became a shared purpose: curating the wellness retreats, and the mindset, they each wished they had when they lost their mothers.";

export const FOUNDERS = [
  {
    id: "shawnie",
    name: "Shawnie Bailey",
    role: "Entrepreneur · Travel Concierge · Founder, Bailey Care Homes, Inc.",
    bio: "Shawnie brings more than three decades of hands-on entrepreneurship — building businesses, planning events, and guiding travelers as a concierge. She has traveled to over 30 countries and traveled with Oprah Winfrey twice: to Australia as part of the Ultimate Viewers Trip, and again in 2019 to Half Moon Cay for the Best Friends Cruise.",
  },
  {
    id: "aunnie",
    name: "Aunnie Williamson",
    role: "Event Architect · Founder, Social Butterfly Event Planning Service",
    bio: "Aunnie brings over 25 years of experience leading Social Butterfly Event Planning Service, known for an innovative, detail-oriented approach to bringing events to life. Known among her girlfriends as the “Social Butterfly,” she has a knack for making ordinary events extraordinary.",
  },
];

export const ORIGIN_STORY =
  "Their three decades of friendship deepened when they each lost their mothers within a short time of one another. In that grief, they reached for something that didn't exist yet — a space to slow down, be held, and simply feel. So they built it. Every retreat they curate is the retreat they each wish they'd had in that season: room to grieve, to rest, and to reconnect.";

export const SIGNATURE_QUOTE =
  "Thoughtfully planned, elegantly styled, and unforgettably experienced.";

export const PILLARS = [
  {
    icon: "sparkles",
    title: "Luxury Wellness Retreats",
    desc: "Custom-curated, high-end global escapes — including the Reset, Rewire Retreat in Bali — designed for deep rest, renewal, and reconnection.",
  },
  {
    icon: "waves",
    title: "Meditation & Sound Baths",
    desc: "Immersive sonic healing and mindfulness ceremonies — from retreat mornings to the intimate “Meditation & MooMoos” women's wellness sleepover.",
  },
  {
    icon: "users",
    title: "Sister Circle Community",
    desc: "Empowerment gatherings, sister circles, and lifelong bonds — a real model for sisterhood and third-space rest, not performative self-care.",
  },
  {
    icon: "plane",
    title: "Travel & Experiences",
    desc: "Bespoke cultural excursions and concierge travel, backed by 30+ countries of firsthand expertise and Pic N Pak Tours and Travel Company.",
  },
];

export const STATS = [
  { value: 55, suffix: "+", label: "Combined Years in Business" },
  { value: 30, suffix: "+", label: "Countries Traveled" },
  { value: 2, suffix: "x", label: "Traveled with Oprah Winfrey" },
  { value: 25, suffix: "+", label: "Years of Event Planning" },
  { value: 30, suffix: "+", label: "Years of Sisterhood" },
];

export const RETREAT = {
  name: "Reset, Rewire Retreat",
  place: "Bali 2026",
  mantra: "Reconnect. Rejuvenate. Rise.",
  dates: "September 15–23, 2026",
  length: "8 nights · 9 days",
  location: "Private Villa · Ubud, Bali",
  price: "$2,600 per person · all rooms",
  countdownTo: "2026-09-15T00:00:00+08:00",
  highlights: [
    "Daily meditation & sound healing",
    "Private luxury villa in the Ubud jungle",
    "Sister circles & empowerment sessions",
    "Curated Balinese cultural experiences",
  ],
};

export const GALLERY = [
  {
    src: "/images/sisters-lunch.jpg",
    title: "Sisters at the Table",
    caption: "A garden lunch gathering — where sisterhood is served family-style.",
  },
  {
    src: "/images/bali-swing.jpg",
    title: "The Bali Swing",
    caption: "Rising above the Ubud jungle — joy, unfiltered.",
  },
  {
    src: "/images/bali-group.jpg",
    title: "Rooftop Nights, Bali",
    caption: "Sister circle under the Balinese night sky.",
  },
  {
    src: "/images/retreat-moment.webp",
    title: "The Long Table",
    caption: "Candlelight, eucalyptus, and room for every story.",
  },
  {
    src: "/images/garden-dinner.jpg",
    title: "Sisterhood Garden Dinner",
    caption: "An evening under the lights, thoughtfully planned to the last candle.",
  },
  {
    src: "/images/red-tablescape.jpg",
    title: "The Signature Tablescape",
    caption: "Bold, elegant, unforgettable — the Social Butterfly touch.",
  },
  {
    src: "/images/oceanside-dinner.jpg",
    title: "Oceanside Terrace Dinner",
    caption: "A long-table celebration by the water at golden hour.",
  },
];
